module.exports = __webpack_public_path__ + "img/矩形 2629.59f23a30.png";